/* eslint-disable */
// @ts-nocheck
import { ORG_VIEW } from '../../common/support/viewConstants';
type DriftConfig = {
  userId: string;
  email: string;
  name: string;
  lastName: string;
  OnboardinStep?: string;
};

class Drift {
  isDriftLoaded() {
    return !!window.drift;
  }

  initialize(config: DriftConfig) {
    const { userId, email, name, lastName, OnboardinStep } = config;

    if (!this.isDriftLoaded()) {
      return;
    }

    const driftPayload = {
      logged_in_user: true,
      email,
      name,
      last_name: lastName,
      onboarding_step: OnboardinStep,
      ...this.getBranchEntityId(),
    };
    window.drift.on('ready', () => window.drift.identify(userId, driftPayload));
  }

  getBranchEntityId() {
    const { current_view: currentView, app_id: branchAppId, organization_id: branchOrgId } = window.App.context.view;
    return currentView === ORG_VIEW
      ? {
          branch_org_id: branchOrgId,
        }
      : {
          branch_app_id: branchAppId,
        };
  }
}

export default Drift;
